import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DeleteOutlined, EditOutlined, ReloadOutlined } from '@ant-design/icons';
import { Table, Modal, Divider, Button } from 'antd';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import _ from 'lodash';
import qs from 'qs';
import { checkPermission } from '@/utils/permission';
import { cleanObject, downloadFromLink, renderBooleanIcon } from '@/utils/helpers';
import HtmlParser from 'react-html-parser';

import { getListPrescriptionTemplate, getSpecificPrescriptionTemplate, removePrescriptionTemplate } from '@/redux/actions/prescriptionTemplateActions';
import PrescriptionTemplateForm from './PrescriptionTemplateForm';

const { confirm } = Modal;

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/prescription-templates',
        breadcrumbName: 'Danh sách mẫu đơn thuốc',
    },
]

class PrescriptionTemplateList extends Component {
    state = {
        isLoading: false,
        selectedRowKeys: [],
        isOpenForm: false,
        currentItem: null,
        currentData: null,
        isOpenDetail: false
    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.loadData(query);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.loadData(query);
        }
    }

    loadData = (query) => {
        this.setState({ isLoading: true });
        this.props.getListPrescriptionTemplate(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }

        query = cleanObject(query);

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    toggleOpenForm(isOpenForm, currentItem = null) {
        this.setState({ isOpenForm: isOpenForm, currentItem: currentItem });
    }

    onEdit(id) {
        this.props.getSpecificPrescriptionTemplate(id).then(res => {
            console.log(res);
            this.toggleOpenForm(true, res);
        })
    }

    onRemove() {
        this.props.removePrescriptionTemplate(this.state.selectedRowKeys).then(() => {
            this.setState({
                selectedRowKeys: []
            });
            setTimeout(() => {
                Modal.destroyAll();
            }, 800);
        })
    }
    openAlert(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá những bản ghi này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.removePrescriptionTemplate(id).then(() => {
                setTimeout(() => {
                    Modal.destroyAll();
                }, 800);
            }),
            onCancel() { },
        })
    }

    onDetail(id) {
        this.setState({ current_id: id })
        this.props.getSpecificPrescriptionTemplate(id).then(res => {
            console.log(res);
            this.toggleOpenDetail(true, res);
        })
    }

    toggleOpenDetail(isOpenDetail, data = null) {
        this.setState({ isOpenDetail: isOpenDetail, currentData: data });
    }

    onDownload(url) {
        setTimeout(() => {
            const response = {
                file: url,
            };
            downloadFromLink(response.file);
        }, 100);
    }

    render() {
        var { prescriptionTemplateList, pagination } = this.props;
        var { isLoading, selectedRowKeys, isOpenForm, currentItem } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const hasSelected = selectedRowKeys.length > 0;

        var query = qs.parse(this.props.location.search.slice(1));

        const allowCreate = checkPermission('prescription_templates', 'create');
        const allowEdit = checkPermission('prescription_templates', 'update');
        const allowRemove = checkPermission('prescription_templates', 'remove');
        const allowDetail = checkPermission('prescription_templates', 'detail');

        const columns = [
            {
                title: '#',
                width: '75px',
                align: 'center',
                render: (text, record) => (
                    <div>
                        {
                            allowEdit ? (
                                <>
                                    <EditOutlined className='color-primary item-action-btn' onClick={() => this.onEdit(record.id)} />
                                    <Divider type='vertical' />
                                </>
                            ) : null
                        }
                        {
                            allowRemove ? (
                                <DeleteOutlined style={{ color: 'red', cursor: 'pointer' }} onClick={() => this.openAlert([record.id])} />
                            ) : null
                        }
                    </div>
                )
            },
            {
                title: 'Tên đơn thuốc',
                dataIndex: 'name',
                key: 'name',
                sorter: true,
                render: (text, record) => {
                    if (allowDetail) {
                        return (
                            <div className='color-primary'>
                                {text}
                            </div>
                        )
                    } else {
                        return (<>{text}</>)
                    }
                }
            },
            {
                title: 'Nội dung',
                dataIndex: 'content',
                key: 'content',
                width: '600px',
                render: (text, record) => {
                    return (
                        <div style={{ wordBreak: "break-word" }}>
                            {HtmlParser(text)}
                        </div>
                    )
                }
            },
            {
                title: 'Trạng thái',
                dataIndex: 'status',
                key: 'status',
                align: 'center',
                render: (text, record) => {
                    return (<>{renderBooleanIcon(text)}</>)
                }
            }
        ];

        return (
            <div>
                <PageTitle routes={routes} title="Danh sách mẫu đơn thuốc" />
                <div>
                    <TableActionBar
                        isShowAddButton={allowCreate}
                        isShowDeleteButton={allowRemove}
                        onAdd={() => this.toggleOpenForm(true)}
                        onDelete={() => this.onRemove()}
                        disabled={!selectedRowKeys.length ? true : false}
                        showFilter={false}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                    >
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData(query)}>Refresh</Button>
                        {
                            hasSelected ? <span>Đang chọn {selectedRowKeys.length} bản ghi</span> : ''
                        }
                    </TableActionBar>
                </div>
                <Table
                    rowKey="id"
                    size="small"
                    tableLayout='auto'
                    dataSource={prescriptionTemplateList ?? []}
                    columns={columns}
                    loading={isLoading}
                    rowSelection={rowSelection}
                    pagination={{
                        pageSize: pagination.perPage,
                        current: pagination.currentPage,
                        total: pagination.total,
                        showTotal: total => `Tổng ${total} bản ghi`
                    }}
                    onChange={(pagination, filters, sorter) => this.onChangeTable(pagination, sorter)}
                    scroll={{
                        x: 'max-content'
                    }}
                />
                <PrescriptionTemplateForm
                    visible={isOpenForm}
                    currentItem={currentItem}
                    reloadData={() => this.loadData(query)}
                    onCancel={() => this.toggleOpenForm(false)}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        prescriptionTemplateList: state.prescriptionTemplateReducer.prescriptionTemplateList,
        pagination: state.prescriptionTemplateReducer.pagination,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getListPrescriptionTemplate: (filter) => dispatch(getListPrescriptionTemplate(filter)),
        getSpecificPrescriptionTemplate: (id) => dispatch(getSpecificPrescriptionTemplate(id)),
        removePrescriptionTemplate: (ids) => dispatch(removePrescriptionTemplate(ids))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PrescriptionTemplateList);
